import { RecaptchaVerifier } from 'firebase/auth';
import { auth } from '../FirebaseConfig';

declare global {
  interface Window {
    recaptchaVerifier: RecaptchaVerifier;
  }
}

export function getOrCreateRecaptchaVerifier(elementId: string): RecaptchaVerifier {
  const recaptchaElement = document.getElementById(elementId);
  if (!recaptchaElement) {
    throw new Error(`reCAPTCHA element with ID "${elementId}" not found`);
  }

  // 1. If a verifier exists, check its health
  const oldVerifier = window.recaptchaVerifier;
  if (oldVerifier && !(oldVerifier as any).destroyed && (oldVerifier as any).container === recaptchaElement) {
    return oldVerifier;
  }

  // 2. If we are here, we need a fresh start. Clear everything.
  if (oldVerifier) {
    try {
      if (!(oldVerifier as any).destroyed) {
        oldVerifier.clear();
      }
    } catch (e) {
      console.warn('Cleanup warning:', e);
    }
    window.recaptchaVerifier = null as any;
  }

  // 3. FORCE reset the DOM and the global Google library
  recaptchaElement.innerHTML = '';
  if ((window as any).grecaptcha && (window as any).grecaptcha.reset) {
    try {
      (window as any).grecaptcha.reset();
    } catch (e) {
      // Ignore if no widget was actually rendered
    }
  }

  // 4. Create new instance
  try {
    const newVerifier = new RecaptchaVerifier(elementId, {
      'size': 'invisible'
    }, auth);

    window.recaptchaVerifier = newVerifier;
    return newVerifier;
  } catch (error) {
    console.error('Error creating RecaptchaVerifier:', error);
    throw new Error('Verification system error. Please refresh the page.');
  }
}